import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import classes from './style.module.css';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux"
import Modal from '../../components/UI/Modal'
import Aux from 'react-aux'
import { SET_MODAL_STATE } from "../../redux/actions"
import { SET_LOGIN_STATE } from "../../redux/actions"
import { logout } from "../../util/login/application-login-utils"
import BannerRow from "../BannerRow"
import HeaderRow from "../HeaderRow"
import BottomRow from "../BottomRow"
import LeagueTable from "../../components/LeagueTable"
import { MODE_HOT_JOCKEY, TICKLER_TAB_BUTTON } from "../../constants/Constants"
import { logInfo } from "../../util/log/logger"
import headerImage from '../../assets/images/header.png'
import RaceSlidingPane from '../../components/RaceSlidingPane';

const Dashboard = props => {
    const [race, setRace] = useState([]);
    const [matchFilter, setMatchFilter] = useState([]);

    const matchFilterHandler = (filter) => {
        setMatchFilter(filter);
    }


    const modalClosedHandler = () => {
        const modalState = { ...props.modalState }
        modalState.show = false;
        modalState.children = null;
        props.setModalState(modalState)
    }

    const logoutHandler = async () => {
        //logInfo(`Dashboard | logoutHandler: `)
        await logout();
        const loginState = { ...props.loginState }
        loginState.isLoggedIn = false;
        props.setLoginState(loginState);
    }

    const raceSelectHandler = (race) => {
        console.log("setting race:" + JSON.stringify(race))
        setRace(race);
    }

    if (!props.loginState.isLoggedIn) {
        return <Redirect to="/login" />
    }
    let content = <LeagueTable race={race} />
    let dashboard = (
        <Container fluid className={classes.Dashboard}>
            <BannerRow bannerImage={headerImage} />
            <HeaderRow active={true} raceSelectHandler={raceSelectHandler} matchFilterHandler={matchFilterHandler} logoutClicked={logoutHandler} />
            <Row className={classes.MiddleRow} noGutters >
            
                {content}
            </Row>
            <BottomRow />
        </Container>
    )

    let modal = null;
    if (props.modalState.show) {
        modal = (
            <Modal show={props.modalState.show}
                modalClosed={modalClosedHandler}
                modalSubmit={() => props.modalState.onSubmit(modalClosedHandler)}
            >
                <p>Model is Being Displayed</p>
            </Modal>
        )
    } else {
        modal = null
    }

    return (
        <Aux>
            {modal}
            {dashboard}
        </Aux>

    )
}

const mapStateToProps = (state, ownProps) => {
    const returnProps = {
        loginState: state.loginState,
        modalState: state.modalState,
        selectionState: state.selectionState,
        ...ownProps
    }
    return returnProps
}

const mapDispatchToProps = dispatch => {
    return {
        setModalState: payload =>
            dispatch({ type: SET_MODAL_STATE, payload: payload }),
        setLoginState: payload =>
            dispatch({ type: SET_LOGIN_STATE, payload: payload }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);